export const Bio = {
  name: "Ayush Das",
  roles: [
    "Full Stack Developer",
    "Programmer",
  ],
  description:
    "I am a motivated software developer and a final year CS undergrad student. Highly interested in Full Stack Development. ",
  github: "https://github.com/AshleyCodes-1",
  resume: "https://drive.google.com/file/d/15TBhQhuNNW-zX8tT-v3O8BKZjgxUdsy3/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ashley-milo/",
  twitter: "https://twitter.com/AshDas19",
  insta: "https://www.instagram.com/milotic_ash/",
  facebook: "https://www.facebook.com/ash.kun.14473",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML5",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS3",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image: "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:"https://vectorified.com/images/express-js-icon-12.png",
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "php",
        image: "https://pngimg.com/uploads/php/php_PNG50.png",
      },
      {
        name: "Laravel",
        image: "https://iconape.com/wp-content/png_logo_vector/laravel-logo-2.png",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Programming Languages & Tools",
    skills: [
      {
        name: "C",
        image: "https://pngimg.com/uploads/letter_c/letter_c_PNG22.png",
      },
      {
        name: "C++",
        image: "https://itsourcecode.com/wp-content/uploads/2022/08/c-logo-1536x1536.png",
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Git",
        image: "https://iconape.com/wp-content/png_logo_vector/git-icon.png",
      },
      {
        name: "GitHub",
        image: "https://www.shareicon.net/data/2016/06/20/606964_github_4096x4096.png",
      },
      {
        name: "Postman",
        image: "https://www.svgrepo.com/show/354202/postman-icon.svg",
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Adobe Photoshop",
        image: "https://pngimg.com/d/photoshop_PNG12.png",
      },
      {
        name: "Da Vinci Resolve",
        image: "https://images.fmctraining.com/images/davinci-logo.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dnsz7woej/image/upload/v1706634013/upskillz_mfe7jr.jpg",
    role: "Full Stack Developer",
    company: "UpSkillZ",
    date: "Apr 2022 - June 2022",
    desc: "Worked on converting static webpages to dynamic webpages. Outsourcing the data to using MySQL and MongoDB databases",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "NodeJS",
      "ExpressJS",
      "MySQL",
      "MongoDB",
    ],
    doc: "https://res.cloudinary.com/dnsz7woej/image/upload/v1704957281/certificate_l9sqag.png",
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://www.static-contents.youth4work.com/university/Documents/Colleges/collegeLogo/52.png?v=20190215154120",
    school: "Thapar Institute of Engineering and Technology, Patiala",
    date: "Sept 2020 - June 2024",
    degree: "Bachelor of Engineering - B.E. Computer Engineering",
  },
  {
    id: 1,
    img: "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/3f409a6136ee82d4c6dbfdb719e417ba",
    school: "Apeejay School, Saltlake, Kolkata",
    date: "Apr 2019 - Mar 2020",
    grade: "Senior Secondary AISSCE - 94.4%",
    desc: "Subjects - Physics, Chemistry, Mathematics, Computer Science, English, Web Application",
    degree: "CBSE (XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/256x256/3f409a6136ee82d4c6dbfdb719e417ba",
    school: "Apeejay School, Saltlake, Kolkata",
    date: "Apr 2017 - Mar 2018",
    grade: "Secondary AISSE - 89.4%",
    desc: "Subjects - Science, Mathematics, Social Science, English, 2nd language (Hindi), Information Technology",
    degree: "CBSE (X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "Fitness 360",
    date: "Jan 2023 - Apr 2023",
    description:
      "Welcome to Fitness 360˚! A complete fitness & wellness website designed and developed using popular Front-End tools. The Database operations are handled by Mongo Atlas. It is a completely responsive website with smooth transitions.",
    image:
      "https://res.cloudinary.com/dnsz7woej/image/upload/v1704959169/x23xzl71msoyb7tjqxbh.jpg",
    tags: [
      "HTML",
      "CSS",
      "BOOTSTRAP",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
    ],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/Fitness360",
    webapp: "https://ashleycodes-1.github.io/Fitness360/",
  },
  {
    id: 2,
    title: "Mama Care",
    date: "Apr 2023 - May 2023",
    description:
      "A Healthcare website especially for pregnant mothers providing a complete information and guide of all trimesters  . Being locally hosted using Xampp. The Database operations are handled by phpMyAdmin that has already included MariaDB",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1705933191/MamaCare_xwwpxz.jpg",
    tags: ["HTML", "CSS", "BOOTSTRAP", "PHP", "Laravel (Framework)", "Xampp", "MySQL"],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/MamaCare",
    webapp: "https://ashleycodes-1.github.io/MamaCare/",
  },
  {
    id: 3,
    title: "AI Snake Pathfinder",
    date: "Apr 2022",
    description:
      "The traditional snake and apple game is now implemented using the power of AI. Using the Breadth-First Search (BFS) algorithm to enable the snake to find the shortest path to the apple.",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1705933210/Snake-Pathfinding_suroey.gif",
    tags: [
      "Python 3",
      "Pygame (module)",
      "Random (module)",
      "BFS Algorithm"
    ],
    category: "ai",
    github: "https://github.com/AshleyCodes-1/AI-Snake-Pathfinder",
    
  },
  {
    id: 4,
    title: "E-Commerce Website",
    date: "Nov 2023 - Present",
    description: "This is an upcoming Full Stack project on 'E-Commerce Website' using the complete MERN stack.",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1707486992/Coming_soon_lgpp7b.png",
    tags: ["NodeJS", "ExpressJS", "ReactJS", "Redux", "MongoDB", "Postman"],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/E-Commerce-Website",
    webapp: "",
  },
  {
    id: 5,
    title: "Attendance using Face Recognition",
    date: "Oct 2022",
    description:
      "This project utilises OpenCV to identify and verify faces of individuals based on the training data from pre updated images.",
    image:
      "https://res.cloudinary.com/dnsz7woej/image/upload/v1706638482/Face_Recognition_Attendance_rmrbnp.jpg",
    tags: ["Python 3", "OpenCV", "Tensor Flow"],
    category: "machine learning",
    github: "https://github.com/AshleyCodes-1/Attendance-using-Face-Recognition",
  },
  {
    id: 6,
    title: "Portfolio Website",
    date: "Jun 2023 - Jul 2023",
    description:
      "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1706686913/Portfolio_vmbmqr.png",
    tags: ["React Native", "JavaScript", "Axios"],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/Portfolio",
    webapp: "https://github.com/AshleyCodes-1/Portfolio",
  },
  {
    id: 7,
    title: "ChatBot using NodejS & GPT 3.5",
    date: "Jan 2024",
    description: "This project is a chatbot built using Node.js and OpenAI's GPT-3.5 Turbo API. This chatbot works in the CLI of the computer and can easily be incorporated to make a standalone chatbot UI for website and apps.",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1706639879/Chatbot_dxswks.png",
    tags: ["NodeJS", "OpenAI", "ChatGPT-3.5 Turbo API"],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/Chatbot-with-NodeJS",
    webapp: "https://github.com/AshleyCodes-1/Chatbot-with-NodeJS",
  },
  {
    id: 8,
    title: "Chatify",
    date: "Jan 2024",
    description: "A chat application using the usecases of NodeJS, ReactJS and REST API via ChatEngine.io",
    image: "https://res.cloudinary.com/dnsz7woej/image/upload/v1707486654/Chatify_ncdxki.jpg",
    tags: ["NodeJS", "ReactJS", "REST API"],
    category: "web dev",
    github: "https://github.com/AshleyCodes-1/Chatify",
    webapp: "https://github.com/AshleyCodes-1/Chatify",
  },
];

